import { useEffect } from 'react';

import { useSnackbar, SnackbarProvider } from 'notistack';

import LogRocket from 'logrocket';

import { HelmetProvider } from 'react-helmet-async';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// components

import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';

import ScrollToTop from './components/ScrollToTop';
// routes
import Router from './routes';
// socket
import SocketController from './SocketController';
import CachingController from './CachingController';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

import preloadImages from './map/preloadImages';

import { LocalizationProvider } from './common/LocalizationProvider';

import store from './store';

// ----------------------------------------------------------------------

export default function App() {
  const { enqueueSnackbar } = useSnackbar();

  window.addEventListener('online', () =>
    enqueueSnackbar(`You're back online.`, { variant: 'success' })
  );
  window.addEventListener('offline', () =>
    enqueueSnackbar('You are offline.', {
      variant: 'warning'
    })
  );

  preloadImages();

  useEffect(() => {
    LogRocket.init(process.env.REACT_APP_LOGROCKET_TOKEN);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Provider store={store}>
          <LocalizationProvider>
            <SnackbarProvider maxSnack={3} resumeHideDuration={1000}>
              <ThemeConfig>
                <ScrollToTop />
                <GlobalStyles />
                <BaseOptionChartStyle />
                <SocketController />
                <CachingController />
                <Router />
              </ThemeConfig>
            </SnackbarProvider>
          </LocalizationProvider>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
